import ApiClient from './ApiClient';

class AccountHolidaysAPI extends ApiClient {
  constructor() {
    super('account_holidays', { accountScoped: true });
  }
}

export default new AccountHolidaysAPI();
